import { Patient } from '../types/patient';
import {Plan} from '../types/patient'


export const johnSmithHealthPlan: Plan = {
  
    "vitals": {
      categoryName: "Vitals & Key Biometrics",
      goals: [
        {
          id: "bp",
          metricName: "Blood Pressure",
          targetDisplay: "< 120/80 mmHg",
          currentValue: "128/84",
          unit: "mmHg",
          actionableSteps: ["Reduce sodium intake", "Take medication at 8:00 AM"],
          source: "Set by Dr. Smith",
          priority: "High",
          visualizationType: "Gauge"
        },
        {
          id: "weight",
          metricName: "Weight",
          targetDisplay: "180 lbs",
          currentValue: 185,
          unit: "lbs",
          actionableSteps: ["Log 3 meals daily", "Walk 30 minutes"],
          source: "Self-set",
          priority: "Medium",
          visualizationType: "LineGraph"
        }
      ]
    },
    
    "activity": {
      categoryName: "Physical Activity",
      goals: [
        {
          id: "steps",
          metricName: "Daily Steps",
          targetDisplay: 8000,
          currentValue: 6500,
          unit: "steps",
          actionableSteps: ["Take a 20-minute walk after lunch"],
          source: "Self-set",
          priority: "Medium",
          visualizationType: "ProgressBar"
        },
        {
          id: "active-minutes",
          metricName: "Daily Active Minutes",
          targetDisplay: 30,
          currentValue: 25,
          unit: "minutes",
          actionableSteps: ["Go for a bike ride", "Try a home workout video"],
          source: "Set by Dr. Smith",
          priority: "High",
          visualizationType: "ProgressBar"
        }
      ]
    },
    
    "medication": {
      categoryName: "Medication & Adherence",
      goals: [
        {
          id: "med-adherence",
          metricName: "Medication Adherence (Lisinopril)",
          targetDisplay: "100%",
          currentValue: "85% (last 7 days)",
          unit: "%",
          actionableSteps: ["Set 8:00 AM phone reminder", "Use weekly pill organizer"],
          source: "Set by Dr. Smith",
          priority: "High",
          visualizationType: "Checklist"
        }
      ]
    },
  
    "sleep": {
      categoryName: "Sleep",
      goals: [
        {
          id: "sleep-duration",
          metricName: "Sleep Duration",
          targetDisplay: "7-9 hours",
          currentValue: "6.5 hours (avg)",
          unit: "hours",
          actionableSteps: ["No screens 1 hour before bed", "Set a 10:30 PM bedtime"],
          source: "Self-set",
          priority: "Medium",
          visualizationType: "LineGraph"
        }
      ]
    }
  };